// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from 'axios';
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/reset.css'
import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'
// import '@/assets/js/Blob.js'
// import '@/assets/js/Export2Excel.js'
// import Blob from './assets/js/Blob'
// import Export2Excel from './assets/js/Export2Excel'
import XLSX from 'xlsx'
//markdown插件 v-md-editor
import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';
// highlightjs
import hljs from 'highlight.js';


VMdPreview.use(githubTheme, {
  Hljs: hljs,
});

Vue.use(VMdPreview);
Vue.prototype.XLSX = XLSX
Vue.use(Element);
Vue.prototype.$message=Element.Message
Vue.prototype.$msgbox=Element.MessageBox
// 引入echarts
import * as echarts from 'echarts'
// Vue.use(echarts);
Vue.prototype.$echarts = echarts

import store from './store/index'
Vue.config.productionTip = false;



import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)



axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$axios = axios;

import router from './router'
Vue.config.productionTip = false;
window.addEventListener('popstate',function(){
  location.reload()
})

Date.prototype.Format = function (fmt) { // author: meizz
  var o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    "S": this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return fmt;
}
new Vue({
  router,
  store,
  render:h=>h(App)
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/main.js